import GridIcon from "../../../../../../../../../assets/svg/grid-icon";
import ListViewIcon from "../../../../../../../../../assets/svg/list-view-icon";

export const layoutOptions = [
  { type: "grid" as const, icon: GridIcon, label: "Grid view" },
  { type: "list" as const, icon: ListViewIcon, label: "List view" },
];
